<template>
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <van-empty image="error" description="获取信息失败,请下拉页面刷新." image-size="300" />
    </van-pull-refresh>
</template>

<script>
    export default {
        data() {
            return {
                count: 0,
                isLoading: false,
                code: "",
            };
        },
        created() {
            this.code = this.$route.query.code;
            console.log("获取到得code:" + this.code);
        },
        methods: {
            onRefresh() {
                var params_json = {
                    code: this.code
                };
                this.$http
                    .post("/web/getOpenId", params_json)
                    .then(function (res) {
                        let obj = res.data;
                        if (obj.openId == " " || obj.openId == "undefined" || obj.openId == "null" || obj.openId ==
                            null || obj
                            .openId == "") {
                            this.isLoading = false;
                            return;
                        } else {
                            window.localStorage.setItem("openid", obj.openId);
                            this.openid = obj.openId;
                            if (obj.msg == "" || obj.msg == null) {
                                this.$router.push({
                                    path: "LoginType",
                                    query: {
                                        code: this.code,
                                        openid: this.openid
                                    }
                                });
                            } else {
                                var strArray = obj.msg.split('#');
                                console.log("返回得用户信息:" + strArray);
                                this.user = [{
                                    "username": strArray[0],
                                    "number": strArray[2],
                                    "shenfen": strArray[1],
                                    "phone": strArray[3],
                                    "openid": this.openid
                                }];
                                window.localStorage.setItem("User", JSON.stringify(this.user));
                                this.$router.push("Index");
                            }
                            this.isLoading = false;
                        }
                    });
            },
        },
    };
</script>